import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface PopupState {
  data: Record<string, any>
  isPopupRendered: boolean
  show: (payload: { id: string; [key: string]: any }) => void
  close: (payload: { id: string }) => void
  closeAll: () => void
}

const usePopupStore = create<PopupState>()(
  devtools(
    (set) => ({
      data: {},
      isPopupRendered: false,
      show: (payload) =>
        set(
          (state) => {
            const { id } = payload
            return {
              data: { ...state.data, [id]: payload },
              isPopupRendered: true,
            }
          },
          false,
          'SHOW_POPUP'
        ),
      close: (payload) =>
        set(
          (state) => {
            const { id } = payload
            return {
              data: { ...state.data, [id]: null },
              isPopupRendered: false,
            }
          },
          false,
          'CLOSE_POPUP'
        ),
      closeAll: () =>
        set(
          () => ({
            data: {},
            isPopupRendered: false,
          }),
          false,
          'CLOSE_ALL_POPUPS'
        ),
    }),
    { name: 'PopupStore' }
  )
)

export default usePopupStore
